import { AsyncEditCustomView } from 'svh-workspace-ui-lib/code-splitting/public';
import { getGatesArray, getIsUngatedForLimitedTicketFunctionality } from '../../selectors/gateSelectors';
import { getScopes } from '../../selectors/userSelectors/getScopes';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { useSelector } from 'react-redux';
import { getDisplayName } from 'find-and-filter-data/views-schema/public';
import { getUserHasCustomViewsAccess } from '../../selectors/userSelectors/getUserHasCustomViewsAccess';
import { addedViewDetails } from '../constants/events';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { CALL_TYPE_ID, CONVERSATION_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
export const EditCustomViewWizard = ({
  customView,
  onReject,
  onSuccess
}) => {
  const gates = useSelector(getGatesArray);
  const scopes = useSelector(getScopes);
  const inboxId = useSelector(getCurrentInboxId);
  const hasCustomViewsAccess = useSelector(getUserHasCustomViewsAccess);
  const shouldLimitTicketFunctionality = useSelector(getIsUngatedForLimitedTicketFunctionality);
  return /*#__PURE__*/_jsx(AsyncEditCustomView, {
    gates: gates,
    scopes: scopes,
    inboxId: inboxId,
    objectTypeIds: shouldLimitTicketFunctionality ? [CALL_TYPE_ID, CONVERSATION_TYPE_ID] : [CALL_TYPE_ID, CONVERSATION_TYPE_ID, TICKET_TYPE_ID],
    customView: customView,
    onConfirm: newName => {
      if (newName !== getDisplayName(customView)) {
        trackEvent(addedViewDetails({
          isNewView: false
        }));
      }
    },
    onReject: onReject,
    onSuccess: onSuccess,
    isReadOnly: !hasCustomViewsAccess
  });
};
EditCustomViewWizard.displayName = 'EditCustomViewWizard';